// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"c2186532","600":"284eaba4","676":"3f11717b","704":"52e81005","808":"ca233935"}[chunkId] + ".chunk.js";
};